/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */
import TimeIntervalDTO from "./TimeIntervalDTO";


interface WorkingHoursRequest {
  /** This will be in minutes, so -360 would be -6 hours or CST */
  timeZoneOffset: string;
  /** Why is this named blocks? Because I wanted to */
  blocks: TimeIntervalDTO[];
}
const WorkingHoursRequest = {
  create: (initValues?: Partial<WorkingHoursRequest> | null): WorkingHoursRequest => {
    const defaults: WorkingHoursRequest = {
      timeZoneOffset: "",
      blocks: [],
    };
    const fixedValues: Partial<WorkingHoursRequest> = initValues != null
      ? {
        blocks: (initValues.blocks ?? []).map(TimeIntervalDTO.create) as TimeIntervalDTO[],
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default WorkingHoursRequest;
